let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jlNCi")).then(() => parcelRequire('4Fevo'));